import React from "react";
import "./Header.css";

const styles = {
  headerStyle: {
    background: "#70D1FF"
  },
  headingStyle: {
    fontSize: 60
  },
  text: {
    textAlign: "center"
  }
};

const Header = () => (
  <header style={styles.headerStyle} className="header">
    <h1 style={styles.headingStyle}>Simpsons</h1>
    <p style={styles.text}>
      Click on an image to earn points, but don't click on any more than once!
    </p>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js